// Report-card generation (exam.md 1.5c.4 stage 1).
//
// Generation is a job: `GENERATE_EXAM_REPORT_CARDS` starts it and answers with the
// run summary, `GET_REPORT_CARD_GENERATION_PROGRESS` is polled alongside it
// against the same `job_id`, and `REGENERATE_REPORT_CARDS` re-runs an existing
// batch from the parameters it was created with.
export const GENERATE_EXAM_REPORT_CARDS = 'GENERATE_EXAM_REPORT_CARDS'
export const GET_REPORT_CARD_GENERATION_PROGRESS = 'GET_REPORT_CARD_GENERATION_PROGRESS'
export const REGENERATE_REPORT_CARDS = 'REGENERATE_REPORT_CARDS'
// Read-only: how many generations this class's branch may still start.
export const GET_REPORT_CARD_GENERATION_SLOTS = 'GET_REPORT_CARD_GENERATION_SLOTS'
